export default "__VITE_ASSET__DmHrZQ0m__"